import styled from 'styled-components';
import { rem } from '@/styles/theme';

export const Content = styled.div`
  padding: 0 ${rem(18)} ${rem(20)};
`;

export const TextWrap = styled.div`
  padding: ${rem(10)} 0 ${rem(20)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${rem(4)};
`;
export const MediaWrap = styled.div`
  padding: 0 0 ${rem(20)};
  display: flex;
  gap: ${rem(6)};
`;

interface IProps {
  theme: any;
  isActive?: boolean;
}
export const MediaLogo = styled.div<IProps>`
  width: -webkit-fill-available;
  height: ${rem(77)};
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 8px;
  ${({ theme, isActive }) =>
    isActive
      ? ` 
         background: #FFF5F6;
         border : 2px solid ${theme.color['primary-100']};
         box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.06);
            `
      : `
         background: ${theme.color.white};
         border: 1px solid ${theme.color['gray-300']};
         box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.06);
   `};
`;

export const ButtonWrap = styled.div`
  padding: ${rem(8)} 0;
`;

export const SubTitleWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 0 ${rem(16)};
`;

export const Image = styled.img``;
